import {FormattableString} from "../FormattableString";
import {currentCulture} from "./currentCulture";

export function translation(message: string, args?: Record<string, any> | null): string;
export function translation(message: FormattableString): string;

export function translation(message: FormattableString | string, args?: Record<string, any> | null | undefined): string {
    return currentCulture().format(message as string, args);
}
